module.exports = __webpack_public_path__ + "img/104075.9c9d9c7f.png";